import fp from 'lodash/fp';
import moment from 'moment';
import * as types from '../../webcommon/header/filterheader/propTypes';
import * as actions from './actions';
import * as constants from './constants';
import { combineColumnPreferences } from '../../common/saveconfiguration/utils';
import makeColumns from './mappings';


export const INITIAL_STATE = {
    columns: makeColumns(false),
    csaSummaries: [],
    unfilteredCsaSummaries: [],
    loading: false,
    filterDefinitions: constants.filterDefinitions,
    defaultFilters: constants.defaultFilters,
    initialised: false,
    lastUpdated: moment().unix(),
    currentServerFilters: null,
    gridSorting: [],
    useDollars: false
};

const setCsaSummaries = fp.set('csaSummaries');
const setLoading = fp.set('loading');
const setColumns = fp.set('columns');
const setInitialised = fp.set('initialised');
const setGridSorting = fp.set('gridSorting');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISED: {
            return setInitialised(action.initialised, state);
        }
        case actions.SET_LOADING: {
            return setLoading(action.loading, state);
        }
        case actions.FETCH_CSASUMMARIES_SUCCEEDED: {
            return {
                ...state,
                csaSummaries: action.data,
                unfilteredCsaSummaries: action.data,
                lastUpdated: moment().unix(),
                currentServerFilters: action.serverFilters
            };
        }
        case actions.FETCH_CSASUMMARIES_FAILED: {
            return setCsaSummaries([], state);
        }
        case actions.SET_DEFAULT_CONFIG: {
            return {
                ...state,
                columns: action.columns && action.columns.length
                    ? combineColumnPreferences(makeColumns(state.useDollars), action.columns)
                    : INITIAL_STATE.columns
            };
        }
        case actions.SET_CSASUMMARIES_COLUMNS: {
            return setColumns(
                combineColumnPreferences(makeColumns(state.useDollars), action.data),
                state
            );
        }
        case actions.APPLY_CLIENT_FILTERS: {
            return fp.set(
                'csaSummaries',
                fp.reduce((rows, filter) => fp.filter((row) => {
                    switch (filter.definition.type) {
                        case types.filterTypes.number:
                        {
                            const value = row[filter.definition.id];
                            let pass = filter.value.from === null || value >= filter.value.from;
                            pass = pass && (filter.value.to === null || value <= filter.value.to);
                            return pass;
                        }
                        default:
                        {
                            return fp.get(row[filter.definition.id]) === filter.value;
                        }
                    }
                })(rows))(state.unfilteredCsaSummaries)(action.clientFilters),
                state
            );
        }
        case actions.SET_GRID_SORTS: {
            const alreadyExists = state.gridSorting.find(sort => sort.gridId === action.gridId);
            if (!alreadyExists) {
                return {
                    ...state,
                    gridSorting: state.gridSorting.concat({
                        gridId: action.gridId,
                        gridSort: action.sorting
                    })
                };
            }

            return {
                ...state,
                gridSorting: state.gridSorting.map(
                    sort => (sort.gridId === action.gridId ? fp.set('gridSort', action.sorting, sort) : sort)
                )
            };
        }
        case actions.SET_ALL_GRID_SORTS: {
            return setGridSorting(action.data, state);
        }
        case actions.SWITCH_CURRENCIES: {
            const currencyString = !state.useDollars ? 'Usd' : 'Eur';
            return {
                ...state,
                useDollars: !state.useDollars,
                columns: state.columns.map((column) => {
                    const idWithoutCurrency = fp.get('idWithoutCurrency')(column);
                    if (idWithoutCurrency) {
                        return {
                            ...column,
                            id: `${idWithoutCurrency}${currencyString}`
                        };
                    }
                    return column;
                })
            };
        }
        default:
            return state;
    }
}
